export const INICIAL = "inicial"; // todo
export const GASOLINA = "gasolina"; // importe total * 70 % = base_cfiva 
export const IMPORTACION = "importacion"; // autorizacion = 3 
export const IMPORTACION_TASA_CERO = "importacion_tasa_cero"; // autorizacion = 3 y importe = tasa cero 
export const SIMPLE = "simple"; // solamente importe con monto
export const COMPUTARIZADA = "computarizada"; // importe con codigo de control
export const SERVICIOS = "servicios"; // importe con tasas llenado
export const TASA_CERO = "tasa_cero"; // importe = tasa cero
export const BOLETO_AVION = "boleto_avion"; // numero de autorizacion = 1
